import React from "react"
import ReactModal from "react-modal"
import PropTypes from "prop-types"

const OpenOrderQRCode = props => {
  const image_url = `https://api.qrserver.com/v1/create-qr-code/?data=${props.paymentUrl}&size=282x282`

  return (
    <ReactModal isOpen={props.isOpen}
      onRequestClose={props.onClose}
      className="react-modal__content"
      contentLabel="Open Order QR Code">
      <div className="qr-code">
        <a href={props.paymentUrl}>
          <img src={image_url}/>
        </a>
      </div>
      <img className="powered-by-plei" src="/images/scan-to-pay.png"/>
    </ReactModal>
  )
}

OpenOrderQRCode.propTypes = {
  isOpen: PropTypes.bool,
  paymentUrl: PropTypes.string,
  onClose: PropTypes.func
}

export default OpenOrderQRCode
